a<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="ml-3 text-2xl font-bold leading-7 text-gray-900 sm:leading-9 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row items-center">
                        Settings
                        <Loader v-if="isFetchListPending"
                                class="-sm ml-2"/>
                    </span>
                </span>
            </h1>
        </PageHeader>

        <div class="mt-8 lg:max-w-6xl lg:mx-auto">
            <div class="m-4">
                <template v-for="setting in settings">
                    <template v-if="setting.type === 'image'">
                        <img v-if="setting.image" class="relative object-contain w-full h-64" :src="setting.image.url" alt="">
                        <FilePckr
                            :id="setting.name.toLowerCase()"
                            :name="setting.name.toLowerCase()"
                            :label="setting.name"
                            :current-url="setting.image ? setting.image.url : null"
                            class="px-6 py-4"
                            @startLoad="handleStartLoadFiles"
                            @endLoad="handleEndLoadFiles"
                        />
                        <button type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-600" @click.prevent="handleSave(setting)">Valider</button>

                    </template>
                    <template v-else-if="setting.type === 'text'">
                        <Input
                            :id="setting.name.toLowerCase()"
                            :name="setting.name.toLowerCase()"
                            :label="setting.name"
                            v-model="setting.value"
                            class="px-6 py-4"
                        />

                        <button type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-600" @click.prevent="handleSave(setting)">Valider</button>
                    </template>
                </template>
            </div>
        </div>
    </main>
</template>

<script>
    import Loader from "../../components/partials/loader"
    import PageHeader from "../../components/partials/page-header";

    import FilePckr from "../../components/form/file-pckr";
    import Input from "../../components/form/input";

    export default {
        data() {
            return {
                image: [],
            }
        },
        computed: {
            settings() {
                return this.$store.state.settings.list;
            },
            isFetchListPending() {
                return this.$store.state.settings.isFetchListPending
            },
            authUser() {
                return this.$store.state.auth.auth_user;
            },
        },
        methods: {
            handleSave(setting) {
                this.$store.dispatch('settings/update', {
                    single: {
                        ...setting,
                        image: this.image,
                    },
                });
            },
            handleStartLoadFiles(images) {
                this.image = images.map( file => file.serverId);
                this.is_filepond_pending = true;
            },
            handleEndLoadFiles(images) {
                this.image = images.map( file => file.serverId);
                this.is_filepond_pending = false;
            }
        },
        components: {
            FilePckr,
            Input,
            Loader,
            PageHeader
        }
    }
</script>


